<template>
  <li
    class="col-xs-4"
    :class="{ active: boxConfig.trigger_button.kind === 'external'}"
    @click="boxUpdateConfig({ item: 'trigger_button', key: 'kind', value: 'external' })"
    >
    <a href="#" class="kp-btn-action-lg-mid">
      <i class="fa fa-external-link"></i>
    </a>
    <div class="kp-tab-label">{{$t('general.labels.button')}}<br>{{$t('general.labels.external')}}</div>
  </li>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  methods: mapActions([
    'boxUpdateConfig',
  ]),
  computed: mapGetters({
    boxConfig: 'boxConfig',
  }),
};
</script>



/** WEBPACK FOOTER **
 ** External.vue?9dcf1088
 **/